import { render, staticRenderFns } from "./FreeInputtableObjectMenu.vue?vue&type=template&id=2789253f&"
import script from "./FreeInputtableObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./FreeInputtableObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FreeInputtableObjectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports